export default __webpack_public_path__ + "images/tap1.49c1de2b0780dbcade4ed031779c5987.png";